import React from 'react'
import CustomTitle from '../CustomTitle/CustomTitle.jsx'









export default function RadiologyProfile() {

   return (
      <>
         <div className="container">
            <CustomTitle title="بروفايلات الاشعة" />
            <h2 className='main-header mt-5 pt-5'>Radiology Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s</p>
            </div>
         </div>
      </>
   )
}
